import { render, staticRenderFns } from "./ListaCreditos.vue?vue&type=template&id=594b06fc"
import script from "./ListaCreditos.vue?vue&type=script&lang=js"
export * from "./ListaCreditos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports